export default __webpack_public_path__ + "static/media/brand-icons.65a2fb6d.ttf";